export default __webpack_public_path__ + "pdfjs-dist-ie11-ledge/text_layer_builder-143b951aeb5eee816476f09df4c55c14.css";